export default {
  computed: {
    currentUser() {
      return this.$user.get()
    },
    userCompanyId() {
      return this.currentUser.company ? this.currentUser.company.id : null
    },
    userCompanyRole() {
      if (this.currentUser.is_superuser) return 'admin'

      if (this.currentUser.company)
        return this.currentUser.company.role
          ? this.currentUser.company.role.role
          : null

      return null
    },
    userCompanyRoleValue() {
      if (this.currentUser.is_superuser) return 'admin'

      if (this.currentUser.company) return this.currentUser.company.role_value
      else return null
    }
  },
  methods: {
    isUserRole(role) {
      return role === this.currentUser.role
    },
    reportNameByRole(report) {
      // Native reports (LIQ-2339/LIQ-2340) have no separate Power-BI-side name to show a
      // superuser instead - editing "Display Name" on the Reports admin page only ever
      // touches display_name (report.name is deliberately left untouched, unlike a real PBI
      // report where it mirrors the actual PBI report name), so this reads display_name
      // directly for native reports rather than falling back to name for superusers.
      if (report.is_native) return report.display_name || report.name

      return this.currentUser.is_superuser
        ? report.name
        : report.display_name || report.name
    },

    isCompanyAdminRow(row) {
      const t = (row && row.type ? String(row.type) : '').trim().toLowerCase();
      return t === 'company admin';
    },

    isSelfRow(row) {
      const me = this.currentUser;
      if (!me) return false;

      const rowEmail = (
        (row && row.user && row.user.email) ? row.user.email :
          (row && row.email) ? row.email :
            ''
      ).toLowerCase();

      const myEmail = (me.email ? String(me.email) : '').toLowerCase();

      return rowEmail && myEmail && rowEmail === myEmail;
    },

    canDeleteRow(row) {
      const me = this.currentUser;
      if (!me) return false;

      if (this.isUserRole('admin') || me.is_superuser) return true;

      if (this.isSelfRow(row)) return false;
      if (this.isCompanyAdminRow(row)) return false;

      return true;
    },

    isRowSelectable(row) {
      return this.canDeleteRow(row);
    },

    deleteDisabledReason(row) {
      const me = this.currentUser;
      if (!me) return '';

      if (me.is_superuser) return '';

      if (this.isSelfRow(row)) {
        return 'You cannot unassign yourself from your own company.';
      }

      if (this.isCompanyAdminRow(row)) {
        return 'You cannot delete other company admins.';
      }

      return '';
    }
  }
}
